import { Injectable } from '@angular/core';

import { LegalEntityLocation } from '../models';
import { FileLoaderService } from './file-loader.service';
import { ConfigurationConstants } from '../constants/config';

@Injectable()
export class LegalEntityLocationsService {

  constructor(private _fileLoaderService: FileLoaderService) {}

  public getLocations(): LegalEntityLocation[] {
    return this._fileLoaderService.load(ConfigurationConstants.ENTITIES_LOCATIONS);
  }
}
